import { Form, Input, message } from "antd";
import { FC, useContext } from "react";
import { v4 as uuidv4 } from "uuid";
import { generateRandomDigits } from "../../../../../helpers";
import { DealsContext } from "../../../../app/context/DealsContext";
import { ConfirmButtons, Modal } from "../../../../ui";
import "./index.less";
import { fullUserSelector, teamSelector } from "src/store/user";
import { useDispatch, useSelector } from "react-redux";
import { setDealsGroupEditingMode } from "src/store/outreach-campaigns";

interface GoIntoDealEditModeProps {
  onClose: () => void;
  setData: () => void;
  colAmnt: number;
}

export const GoIntoDealEditMode: FC<GoIntoDealEditModeProps> = ({ onClose, colAmnt, setData, saveUpd, deals }) => {
  // const { addColumn } = useContext(DealsContext);
  // const [form] = Form.useForm();
  const dispatch = useDispatch();
  const handleSubmitBtnClick = () => {
    dispatch(setDealsGroupEditingMode(true));
    onClose();
    // form
    //   .validateFields()
    //   .then((values) => {
    //     const newGroup = {
    //       id: uuidv4(),
    //       title: values.name,
    //       order: colAmnt + 1,
    //       totalPrice: 0,
    //       deals: [],
    //     };
    //     setData([...deals, newGroup]);
    //     saveUpd([...deals, newGroup]);
    //     message.success("Added column");
    //     onClose();
    //   })
    //   .catch((errorInfo) => {
    //     console.error("Validation failed:", errorInfo);
    //   });
  };

  const { hasTeam } = useSelector(teamSelector);
  const { user } = useSelector(fullUserSelector);
  return (
    // <div style={{ position: "fixed", top: 0, left: 0, width: "100vw", height: "100vh", zIndex: 150000 }}>
    <Modal open={true} title={"Edit Deals Columns"} onCancel={onClose} rootClassName={"add-column-modal"} style={{ zIndex: "99999999 !important" }}>
      {hasTeam ? `Any edits in the column will affect all the team members columns.` : ""}
      <br />
      <br />
      <br />
      {/* <Form form={form} layout={"vertical"} requiredMark={false} className={"add-column-form"}>
        <Form.Item
          name={"name"}
          label={"Name"}
          rules={[
            {
              required: true,
            },
          ]}
        >
          <Input placeholder={"Enter Text"} />
        </Form.Item>
      </Form> */}
      <ConfirmButtons
        leftButtonTitle={"Back"}
        rightButtonTitle={"Edit mode"}
        className={"confirm-buttons"}
        handleSubmit={handleSubmitBtnClick}
        onCancel={onClose}
        disabled={user?.teamStatus === "basic"}
        disabledExplanation="You need to be an admin to edit team settings."
      />
    </Modal>
    // </div>
  );
};
